import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  debounce,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  LinearProgress,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  ListItemText,
  OutlinedInput,
  Divider,
} from '@mui/material';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useContext, useEffect, useState } from 'react';
import CustomTableSortLabel from '../../components/custom-table-sort-label/CustomTableSortLabel';
import PageTitle from '../../components/page-title/PageTitle';
import { useMedicalCertificateService } from '../../hooks/services/useMedicalCertificateService';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IMedicalCertificate from '../../interfaces/IMedicalCertificate';
import IPage from '../../interfaces/IPage';
import { Container } from './FollowupList.styled';
import CustomTablePagination from '../../components/custom-table-pagination/CustomTablePagination';
import moment from 'moment';
import { TbReload } from 'react-icons/tb';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SelectCheckbox from '../../components/select-form/SelectCheckbox';
import ISelectOption from '../../components/select-form/interfaces/ISelectOption';

import FollowupSearchEmployee from './FollowupSearchEmployee';
import IEmployee from '../../interfaces/IEmployee';
import FollowupReportListRow from './FollowupReportListRow';
import { LoadingButton } from '@mui/lab';
import ICompany from '../../interfaces/ICompany';
import SearchCompany from '../../components/searchCompany/SearchCompany';
import SearchSubsidiary from '../../components/searchSubsidiary/SearchSubsidiary';
import SearchProfessionalName from '../../components/SearchProfessionalName/SearchProfessionalName';
import SearchRegisterNumber from '../../components/SearchRegisterNumber/SearchRegisterNumber';

import ISubsidiary from '../../interfaces/ISubsidiary';
import IPost from '../../interfaces/IPost';
import SearchPost from '../../components/searchPost/SearchPost';
import ILocal from '../../interfaces/ILocal';
import SearchLocal from '../../components/searchLocal/SearchLocal';
import * as XLSX from 'xlsx';
import IDiseaseClassification from '../../interfaces/IDiseaseClassification';
import React from 'react';
import { useDiseaseClassificationService } from '../../hooks/services/useDiseaseClassificationService';
import ITypeDocument from '../../interfaces/ITypeDocument';
import { useTypeDocumentService } from '../../hooks/services/useTypeDocumentService';
import SearchWorkShift from '../../components/searchWorkShift/SearchWorkShift';
import IWorkShift from '../../interfaces/IWorkShift';
import { useTenantService } from '../../hooks/services/useTenantService';
import ITenant from '../../interfaces/ITenant';
import UserContext from '../../context/user/UserContext';
import ICostCenter from '../../interfaces/ICostCenter';
import SearchCostCenter from '../../components/searchCostCenter/SearchCostCenter';
import { getStickyProps, HeaderConfig } from '../../hooks/util/useStickTable';
import useCpfCnpjFormat from '../../hooks/util/useCpfCnpjFormat';
import FollowupStatus from './FollowupStatus';
import { getTimeQuanitity } from './followupUtil';
import SouthIcon from '@mui/icons-material/South';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import SegmentIcon from '@mui/icons-material/Segment';
import { hasAccessToAction } from '../../util/hasAccessTo';
import ManageSearchSharpIcon from '@mui/icons-material/ManageSearchSharp';

interface FollowupListProps extends IPage { }

const statusFilters = [
  { value: 'PENDING', label: 'Pendente' },
  { value: 'APPROVED', label: 'Aprovado' },
  { value: 'APPROVEDBYMANAGER', label: 'Aprovado pelo gestor' },
  { value: 'DISAPPROVED', label: 'Reprovado' },
  { value: 'DISAPPROVEDBYMANAGER', label: 'Reprovado pelo gestor' },
  { value: 'ARCHIVED', label: 'Arquivado' },
  { value: 'ARCHIVEDBYMANAGER', label: 'Arquivado pelo gestor' },
];

const statusIntegration = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'SUCCESS', label: 'Sim' },
  { value: 'ERROR', label: 'Não' },
];

const gendersFilters = [
  { value: 'TODOS', label: 'Todos' },
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
];

const FollowupReportList = (props: FollowupListProps) => {
  window.document.title = props.title;

  const { state } = useContext(UserContext);
  const { resources } = state;

  const [medicalCertificates, setMedicalCertificates] = useState<IMedicalCertificate[]>([]);
  const [reports, setReports] = useState<IMedicalCertificate[]>([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [orderDirection, setOrderDirection] = useState<'asc' | 'desc'>('asc');
  const [orderField, setOrderField] = useState<string>('createdAt');
  const [loading, setLoading] = useState(false);
  const [employee, setEmployee] = useState<IEmployee | null>(null);
  const [professionalName, setProfessionalName] = useState<string | null>('');
  const [registerNumber, setRegisterNumber] = useState<string | null>('');
  const [statusSelected, setStatusSelected] = useState<ISelectOption[]>([{ value: 'PENDING', label: 'Pendente' }]);
  const [integrationSelected, setIntegrationSelected] = useState<string>('TODOS');

  const [dateDocumentInitial, setDateDocumentInitial] = useState<moment.Moment | null>(null);
  const [dateDocumentFinal, setDateDocumentFinal] = useState<moment.Moment | null>(null);

  const [dateShippingInitial, setDateShippingInitial] = useState<moment.Moment | null>(null);
  const [dateShippingFinal, setDateShippingFinal] = useState<moment.Moment | null>(null);
  const [company, setCompany] = useState<ICompany | null>(null);
  const [subsidiary, setSubsidiary] = useState<ISubsidiary | null>(null);
  const [local, setLocal] = useState<ILocal | null>(null);
  const [post, setPost] = useState<IPost | null>(null);
  const [workShift, setWorkShift] = useState<IWorkShift | null>(null);
  const [documentTypeId, setDocumentTypeId] = useState<number | null>(null);
  const [documentTypes, setDocumentTypes] = useState<ITypeDocument[] | null>(null);
  const [options, setOptions] = React.useState<readonly IDiseaseClassification[]>([]);
  const [timeQuantity, setTimeQuantity] = React.useState<Number | string>('');
  const [genderSelected, setGenderSelected] = useState<string>('TODOS');
  const [selectedDiseases, setSelectedDiseases] = useState<IDiseaseClassification[]>([]);
  const [tenant, setTenant] = useState<ITenant | null>(null);
  const [seeCID, setSeeCid] = useState<boolean>(false);
  const [costCenters, setCostCenters] = useState<ICostCenter | null>(null);

  const { formatCpf } = useCpfCnpjFormat();

  const { resourcesWithActions } = state;

  const isEdit = hasAccessToAction(
    ["relatório-atestado-web"],
    resourcesWithActions,
    "Editar"
  );

  const headers: HeaderConfig[] = [
    { field: 'protocol_number', label: 'Protocolo', render: (row) => row.protocolNumber },
    { field: 'employee_code', label: 'Matrícula', sticky: true, width: 100, render: (row) => row.employee?.code },
    { field: 'employee_name', label: 'Colaborador', sticky: true, width: 200, render: (row) => row.employee?.name },
    { field: 'employee_cpf', label: 'CPF Colaborador', render: (row) => formatCpf(`${row.employee?.cpf}`) },
    { field: 'company_code', label: 'Código da Empresa', render: (row) => row.employee?.company?.code },
    { field: 'employee_subsidiary.name', label: 'Nome da Filial', render: (row) => `${row.employee?.subsidiary?.code} - ${row.employee?.subsidiary?.name}` },
    { field: 'employee_workShift', label: 'Turno do colaborador', render: (row) => row.employee?.workShift?.description },
    { field: 'employee_admissionDate', label: 'Data da admissão', render: (row) => moment(row.employee?.admissionDate).format('DD/MM/yyyy') },
    { field: 'company.createAt', label: 'Tempo de empresa', render: (row) => companyTime(row.employee?.admissionDate ?? '') },
    { field: 'costCenterId', label: 'Centro de Custo', render: (row) => row.employee?.costCenter?.name },
    { field: 'local_code', label: 'Código do Local', render: (row) => row.employee?.local?.code },
    { field: 'post_code', label: 'Código do Cargo', render: (row) => row.employee?.post?.code },
    { field: 'workstation_code', label: 'Código do Posto de Trabalho', render: (row) => row.employee?.workstation?.code },
    { field: 'workShift_code', label: 'Código da Escala de Trabalho', render: (row) => row.employee?.workShift?.code },
    { field: 'documentDate', label: 'Data do Documento', render: (row) => moment(row.documentDate).format('DD/MM/yyyy') },
    { field: 'startTime', label: 'Data/Hora de Inicio', render: (row) => moment(row.startTime).format('DD/MM/YYYY HH:mm') },
    { field: 'endTime', label: 'Data/Hora de Fim', render: (row) => moment(row.endTime).format('DD/MM/YYYY HH:mm') },
    { field: 'typeTime', label: 'Dias/Horas', render: (row) => row.typeTime === 'DAY' ? 'Dias' : 'Horas' },
    { field: 'timeQuantity', label: 'Tempo', render: (row) => getTimeQuanitity(row) },
    { field: 'status', label: 'Situação', render: (row) => <FollowupStatus status={row.status} /> },
    { field: 'statusIntegration', label: 'Integrado', render: (row) => row.statusIntegration },
    { field: 'typeDocument_description', label: 'Tipo do Documento', render: (row) => row.typeDocument?.description },
    {
      field: 'diseaseClassifications_code', label: 'CIDs',
      render: (row) => seeCID ?
        row.diseaseClassifications.map((diseaseClassification: IDiseaseClassification) =>
          diseaseClassification.code).join(', ') : '****'
    },
    { field: 'professionalTypeName', label: 'Tipo Profissional', render: (row) => row.professionalTypeName },
    { field: 'professionalState', label: 'Estado Profissional', render: (row) => row.professionalState },
    { field: 'registerNumber', label: 'Número Profissional', render: (row) => row.registerNumber },
    { field: 'professionalName', label: 'Nome Profissional', render: (row) => row.professionalName },
    { field: 'origin', label: 'Canal de envio', render: (row) => row.origin === 'WEBAPP' ? 'Usuário' : 'Sistema' },
    { field: 'gender', label: 'Gênero', render: (row) => row.employee?.gender === 'M' ? 'Masculino' : 'Feminino' },
  ];

  const request = useMedicalCertificateService();
  const requestDiseaseClassification = useDiseaseClassificationService();
  const requestTenant = useTenantService();

  const requestTypeDocument = useTypeDocumentService();
  const toastr = useToastrVanila();

  interface IFilter {
    status?: ISelectOption[];
    statusIntegration?: string;
    dateDocumentInitial?: string;
    dateDocumentFinal?: string;
    dateShippingInitial?: string;
    dateShippingFinal?: string;
    companyId?: string;
    subsidiaryId?: string;
    localId?: string;
    postCode?: string;
    workShiftId?: string;
    typeDocumentId?: number | null;
    workstationId?: string;
    employeeId?: string | null;
    professionalName?: string | null;
    registerNumber?: string | null;
    selectedDiseases?: string[] | null;
    timeQuantity?: string | null;
    gender?: string;
    costCenterId?: string | null;
  }

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
    filters?: IFilter,
  ) => {
    setLoading(true);

    const status = filters?.status?.map(s => s.value) || statusSelected.map(s => s.value);
    const statusIntegration = filters?.statusIntegration || integrationSelected;
    const auxDateDocumentInitial = filters?.dateDocumentInitial || dateDocumentInitial?.format('yyyy-MM-DD');
    const auxDateDocumentFinal = filters?.dateDocumentFinal || dateDocumentFinal?.format('yyyy-MM-DD');
    const auxDateShippingInitial = filters?.dateShippingInitial || dateShippingInitial?.format('yyyy-MM-DD');
    const auxDateShippingFinal = filters?.dateShippingFinal || dateShippingFinal?.format('yyyy-MM-DD');
    const companyId = filters?.companyId || `${company?.id}`;
    const subsidiaryId = filters?.subsidiaryId || `${subsidiary?.id}`;
    const localId = filters?.employeeId || `${local?.id}`;
    const postCode = filters?.employeeId || `${post?.code}`;
    const documentTypeFilter = filters?.typeDocumentId || documentTypeId;
    const employeeId = filters?.employeeId || `${employee?.id}`;
    const professionalNameFilter = filters?.professionalName || `${professionalName}`;
    const registerNumberFilter = filters?.registerNumber || `${registerNumber}`;
    const diseaseFilter = filters?.selectedDiseases || selectedDiseases;
    const timeQuantityFilter = filters?.timeQuantity || timeQuantity;
    const genderFilter = filters?.gender || genderSelected;
    const costCenterId = filters?.costCenterId || costCenters?.id || null;

    await request
      .listForFollowupReport(perPage, currentPage + 1, orderField, orderDirection, {
        status,
        dateDocumentInitial: `${auxDateDocumentInitial}`,
        dateDocumentFinal: `${auxDateDocumentFinal}`,
        dateShippingInitial: `${auxDateShippingInitial}`,
        dateShippingFinal: `${auxDateShippingFinal}`,
        companyId,
        subsidiaryId,
        localId,
        postCode: postCode,
        employeeId,
        statusIntegration,
        professionalName: professionalNameFilter,
        registerNumber: registerNumberFilter,
        disease: diseaseFilter ? diseaseFilter.join(',') : null,
        timeQuantity: Number(timeQuantityFilter),
        workShiftId: String(workShift?.id) || null,
        typeDocumentId: documentTypeFilter,
        gender: genderFilter,
        costCenterId: costCenterId
      })
      .then(result => {
        setMedicalCertificates([...result.data]);
        setReports([...(result.reports ?? [])]);
        setTotalRows(result.totalRows);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  const listTypeDocument = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    orderDirection: 'asc' | 'desc',
  ) => {
    setLoading(true);

    await requestTypeDocument
      .list(perPage, currentPage + 1, orderField, orderDirection)
      .then(result => {
        setDocumentTypes(result.data);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(error.message);
      });
  };

  const handleOpenDialog = (medicalCertificate: IMedicalCertificate) => { };

  const handleSubmit = async () => {
    list(perPage, currentPage, orderField, orderDirection);
  };

  const handleDownloadExcel = async () => {
    const rows = reports.map(medicalCertificate => ({
      Protocolo: medicalCertificate.protocolNumber,
      Matricula: medicalCertificate?.employee?.code,
      Nome: medicalCertificate?.employee?.name,
      CPF: medicalCertificate?.employee?.cpf,
      'Código Da Empresa': medicalCertificate?.employee?.company?.code,
      'Código da Filial': medicalCertificate?.employee?.subsidiary?.code,
      'Nome da Filial': medicalCertificate?.employee?.subsidiary?.name,
      'Turno do colaborador': medicalCertificate?.employee?.workShift?.description,
      'Data da admissão': moment(medicalCertificate?.employee?.admissionDate).format('DD/MM/yyyy'),
      'Tempo de empresa': companyTime(medicalCertificate?.employee?.admissionDate ?? ''),
      'Centro de Custo': medicalCertificate?.employee?.costCenter?.name,
      'Código do Local': medicalCertificate?.employee?.local?.code,
      'Nome do Local': medicalCertificate?.employee?.local?.name,
      'Código do Posto de Trabalho': medicalCertificate?.employee?.workstation?.code,
      'Nome do Posto de Trabalho': medicalCertificate?.employee?.workstation?.name,
      'Código da Escala de Trabalho': medicalCertificate?.employee?.workShift?.code,
      'Descrição da Escala de Trabalho': medicalCertificate?.employee?.workShift?.description,
      'Código do Cargo de Trabalho': medicalCertificate?.employee?.post?.code,
      'Nome do Cargo de Trabalho': medicalCertificate?.employee?.post?.name,
      'Data do Documento': moment(medicalCertificate?.documentDate).format('DD/MM/yyyy'),
      'Data/Hora de Inicio': moment(medicalCertificate?.startTime).format('DD/MM/yyyy HH:MM'),
      'Data/Hora de Fim': moment(medicalCertificate?.endTime).format('DD/MM/yyyy HH:MM'),
      'Dias/Horas': medicalCertificate?.typeTime === 'DAY' ? 'Dias' : 'Horas',
      Tempo:
        medicalCertificate?.typeTime === 'DAY'
          ? medicalCertificate?.timeQuantity / 24 + ' Dias'
          : medicalCertificate?.timeQuantity,

      Situação: medicalCertificate?.status,
      Integrado: medicalCertificate?.statusIntegration,
      'Tipo do Documento': medicalCertificate?.typeDocument?.description,
      CIDs: seeCID
        ? medicalCertificate?.diseaseClassifications.map(diseaseClassification => diseaseClassification.code).join(', ')
        : '****',
      'Tipo Profissional': medicalCertificate?.professionalTypeName,
      'Estado Profissional': medicalCertificate?.professionalState,
      'Número Profissional': medicalCertificate?.registerNumber,
      'Nome Profissional': medicalCertificate?.professionalName,
      'Canal de envio': medicalCertificate?.origin === 'WEBAPP' ? 'Usuário' : 'Sistema',
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(rows);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório');

    XLSX.writeFile(workbook, 'relatorio.xlsx', { compression: true });
  };

  const getTenant = async () => {
    setLoading(true);
    await requestTenant
      .getTenant()
      .then(result => {
        setTenant({ ...result });
        setLoading(false);
        return tenant;
      })
      .catch(error => {
        toastr.error(error.message);
        setLoading(false);
      });
  };

  const loadDiseases = debounce(async (filter = '') => {
    setLoading(true);
    await requestDiseaseClassification
      .list(filter)
      .then(diseaseClassification => {
        setOptions([...diseaseClassification, {}]);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoading(false);
      });
  }, 500);

  useEffect(() => {
    getTenant();
    userSeeCID();
  }, []);

  const userSeeCID = async () => {
    if (
      !tenant?.showCIDForManager &&
      resources?.some(resource => resource === 'atestado-digital-gestor') &&
      resources?.length === 1
    ) {
      setSeeCid(false);
      return;
    } else {
      setSeeCid(true);
    }
  };

  useEffect(() => {
    let active = true;

    (async () => {
      if (active) {
        await listTypeDocument(300, 0, 'description', 'asc');
      }
    })();
  }, []);

  const companyTime = (admissionDate: string) => {
    const currentDate = moment();
    const companyDate = moment(admissionDate);

    const years = currentDate.diff(companyDate, 'years');
    const months = currentDate.diff(companyDate.add(years, 'years'), 'months');

    if (years > 0 && months > 0) return `${years} ano(s) e ${months} mês(es)`;
    if (years > 0) return `${years} ano(s)`;
    return `${months} mês(es)`;
  };

  return (
    <Container>
      <PageTitle title="RELATÓRIO DO FOLLOWUP">
        <Tooltip title="Atualizar dados" placement="left">
          <IconButton onClick={() => list(perPage, currentPage, orderField, orderDirection)}>
            <TbReload />
          </IconButton>
        </Tooltip>
      </PageTitle>
      <Box sx={{ marginTop: 1 }}>
        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
            <Typography>Filtros</Typography>
          </AccordionSummary>
          <Divider />
          <AccordionDetails>

            <Grid container spacing={2}>
              <Grid item md={4} sm={6} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
                  Status:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={6} sm={6} xs={12}>
                    <SelectCheckbox
                      label="Situação"
                      size="small"
                      options={statusFilters}
                      selectds={statusSelected}
                      onChange={value => {
                        setCurrentPage(0);
                        setStatusSelected(value);
                      }}
                      limitTags={2}
                    />
                  </Grid>
                  <Grid item md={6} sm={6} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="select-integration">Integração</InputLabel>
                      <Select
                        labelId="select-integration"
                        label="Integrado"
                        onChange={data => {
                          setIntegrationSelected(data.target.value);
                          setCurrentPage(0);
                        }}
                        value={integrationSelected}
                        sx={{ height: '40px' }}
                      >
                        {statusIntegration.map(integration => (
                          <MenuItem key={integration.value} value={integration.value}>
                            {integration.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} sm={12} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
                  Período do documento:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item md={6} sm={6} xs={6}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={dateDocumentInitial}
                        label="Data Inicial Documento"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setDateDocumentInitial(e);
                          }
                        }}
                        renderInput={params => (
                          <TextField {...params} size="small" placeholder="Data Inicial do Documento" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item md={6} sm={6} xs={12}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={dateDocumentFinal}
                        label="Data Final do Documento"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setDateDocumentFinal(e);
                          }
                        }}
                        renderInput={params => (
                          <TextField {...params} size="small" placeholder="Data Final do Documento" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={4} sm={6} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', mb: 1, fontWeight: 500 }}>
                  Período do envio:
                </Typography>

                <Grid container spacing={2}>
                  <Grid item md={6} sm={6} xs={12}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={dateShippingInitial}
                        label="Data Inicial do Envio"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setDateShippingInitial(e);
                          }
                        }}
                        renderInput={params => (
                          <TextField {...params} size="small" placeholder="Data Inicial do Envio" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>

                  <Grid item md={6} sm={6} xs={12}>
                    <LocalizationProvider
                      dateAdapter={AdapterMoment}
                      localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                      <DatePicker
                        value={dateShippingFinal}
                        label="Data Final do Envio"
                        onChange={e => {
                          if (moment(e).isValid()) {
                            setCurrentPage(0);
                            setDateShippingFinal(e);
                          }
                        }}
                        renderInput={params => (
                          <TextField {...params} size="small" placeholder="Data Final do Envio" fullWidth />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={12} sm={6} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', fontWeight: 500 }}>
                  Companhia:
                </Typography>

                <Grid container spacing={2}>
                  <Grid item md={3} sm={6} xs={12}>
                    <SearchCompany
                      setCompany={company => {
                        setCurrentPage(0);
                        setCompany(company);
                      }}
                      company={company}
                    />
                  </Grid>

                  <Grid item md={3} sm={6} xs={12}>
                    <SearchSubsidiary
                      setSubsidiary={subsidiary => {
                        setCurrentPage(0);
                        setSubsidiary(subsidiary);
                      }}
                      subsidiary={subsidiary}
                    />
                  </Grid>

                  <Grid item md={3} sm={6} xs={12}>
                    <SearchCostCenter
                      setCostCenter={costCenter => {
                        setCurrentPage(0);
                        setCostCenters(costCenter);
                      }}
                      costCenter={costCenters}
                    />
                  </Grid>

                  <Grid item md={3} sm={6} xs={12}>
                    <SearchLocal
                      setLocal={local => {
                        setCurrentPage(0);
                        setLocal(local);
                      }}
                      local={local}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={12} sm={6} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', fontWeight: 500 }}>
                  Colaborador:
                </Typography>

                <Grid container spacing={2}>
                  <Grid item md={3} sm={2} xs={12}>
                    <SearchWorkShift
                      setWorkShift={workShift => {
                        setCurrentPage(0);
                        setWorkShift(workShift);
                      }}
                      workShift={workShift}
                    />
                  </Grid>

                  <Grid item md={3} sm={2} xs={12}>
                    <SearchPost
                      setPost={post => {
                        setCurrentPage(0);
                        setPost(post);
                      }}
                      post={post}
                    />
                  </Grid>

                  <Grid item md={3} sm={2} xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel id="professional-state">Tipo de documento</InputLabel>
                      <Select
                        labelId="Tipo de documento"
                        type="number"
                        id="document-type"
                        value={documentTypeId}
                        label="Informe a Situação"
                        onChange={e => setDocumentTypeId(Number(e.target.value))}
                        MenuProps={{ sx: { maxHeight: '300px' } }}
                      >
                        {documentTypes?.map((documentType, i) => {
                          return (
                            <MenuItem value={documentType.id} key={i}>
                              {documentType.description}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item md={3} sm={2} xs={12}>
                    <FollowupSearchEmployee
                      setEmployee={employee => {
                        setCurrentPage(0);
                        setEmployee(employee);
                      }}
                      employee={employee}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={12} sm={6} xs={12}>
                <Typography variant="overline" sx={{ color: 'text.secondary', display: 'block', fontWeight: 500 }}>
                  Documento Médico:
                </Typography>

                <Grid container spacing={2}>
                  <Grid item md={3} sm={3} xs={12}>
                    <SearchProfessionalName ProfessionalName={professionalName} setProfessionalName={setProfessionalName} />
                  </Grid>
                  <Grid item md={2} sm={3} xs={12}>
                    <SearchRegisterNumber RegisterNumber={registerNumber} setRegisterNumber={setRegisterNumber} />
                  </Grid>
                  {seeCID && (
                    <Grid item md={3} sm={3} xs={12}>
                      <FormControl fullWidth size="small">
                        <InputLabel id="disease-classifications-label">CID</InputLabel>
                        <Select
                          labelId="disease-classifications-label"
                          multiple
                          value={selectedDiseases}
                          onChange={event => {
                            const {
                              target: { value },
                            } = event;
                            setSelectedDiseases(
                              typeof value === 'string'
                                ? value.split(',').map(code => ({ code, description: '' }))
                                : (value as IDiseaseClassification[]),
                            );
                          }}
                          input={<OutlinedInput label="CID" />}
                          renderValue={selected => selected.map(s => s).join(', ')}
                          onOpen={() => loadDiseases('')}
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 48 * 4.5 + 8,
                                width: 250,
                              },
                            },
                          }}
                        >
                          <MenuItem>
                            <TextField
                              size="small"
                              autoFocus
                              placeholder="Buscar CID..."
                              fullWidth
                              onChange={e => loadDiseases(e.target.value)}
                              onClick={e => e.stopPropagation()}
                            />
                          </MenuItem>
                          {options.map(
                            disease =>
                              disease.code && (
                                <MenuItem key={disease.code} value={disease.code}>
                                  <ListItemText primary={`${disease.code} - ${disease.description}`} />
                                </MenuItem>
                              ),
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                  )}

                  <Grid item md sm={4} xs={4}>
                    <TextField
                      fullWidth
                      type="number"
                      placeholder="Quantidade de dias"
                      label="Quantidade de dias"
                      value={timeQuantity}
                      onChange={e => {
                        if (Number(e.target.value) >= 0) {
                          setTimeQuantity(e.target.value);
                        }
                      }}
                      size="small"
                      sx={{ padding: 'none' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            ></div>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item md sm={2} xs={12}>
                    <FormControl fullWidth>
                      <InputLabel id="select-gender">Gênero</InputLabel>
                      <Select
                        labelId="select-gender"
                        label="Gênero"
                        onChange={data => {
                          setGenderSelected(String(data.target.value));
                          setCurrentPage(0);
                        }}
                        value={genderSelected}
                        sx={{ height: '40px' }}
                      >
                        {gendersFilters.map(integration => (
                          <MenuItem key={integration.value} value={integration.value}>
                            {integration.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container item spacing={2} sx={{ marginTop: 1 }}>
              <Grid item>
                <LoadingButton onClick={handleSubmit} loading={loading} variant='contained' color='primary' >
                  <SegmentIcon sx={{ marginRight: 1 }} fontSize='small' />
                  Listar
                </LoadingButton>
              </Grid>
              <Grid item>
                <Button
                  onClick={() => {
                    setEmployee(null);
                    setStatusSelected([{ value: 'PENDING', label: 'Pendente' }]);
                    setIntegrationSelected('TODOS');
                    setDateDocumentInitial(null);
                    setDateDocumentFinal(null);
                    setDateShippingInitial(null);
                    setDateShippingFinal(null);
                    setProfessionalName('');
                    setRegisterNumber('');
                    setDocumentTypeId(null);
                    setGenderSelected('TODOS');
                    setTimeQuantity('');
                    setCompany(null);
                    setSubsidiary(null);
                    setLocal(null);
                    setPost(null);
                    setSelectedDiseases([]);
                    setCurrentPage(0);
                    setCostCenters(null);
                    handleSubmit();
                  }}
                  variant='contained'
                  color='secondary'
                >
                  <SearchOffIcon sx={{ marginRight: 1 }} fontSize='small' />
                  Limpar Filtros
                </Button>
              </Grid>
              <Grid item sx={{ marginLeft: 'auto' }}>
                <Button onClick={handleDownloadExcel} disabled={reports.length === 0 || !isEdit} color='success' variant='contained'>
                  <SouthIcon sx={{ marginRight: 1 }} fontSize='small' />
                  Baixar Excel
                </Button>
              </Grid>
            </Grid>

          </AccordionDetails>
        </Accordion>
      </Box>

      <TableContainer component={Paper} sx={{
        marginTop: 2,
        maxHeight: 'calc(100vh - 160px)',
        overflow: 'auto',
      }}>
        {loading && <LinearProgress />}
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((head, index) => {
                return (
                  <CustomTableSortLabel
                    key={head.field}
                    sx={getStickyProps(headers, index, true)}
                    perPage={perPage}
                    currentPage={currentPage}
                    orderField={orderField}
                    field={head.field}
                    label={head.label}
                    handleRequest={list}
                    direction={orderDirection}
                    setField={setOrderField}
                    setDirection={setOrderDirection}
                  />
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {medicalCertificates.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headers.length + 2} sx={{ border: 0, padding: 0 }}>
                  <Box
                    sx={{
                      position: 'sticky',
                      left: 0,
                      maxWidth: 'calc(100vw - 48px)',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '0.5rem',
                      py: 4,
                    }}
                  >
                    <ManageSearchSharpIcon sx={{ fontSize: 52, color: 'text.disabled' }} />
                    <Box sx={{ fontSize: '1.1rem', fontWeight: 500, color: 'text.secondary' }}>
                      Nenhum registro encontrado
                    </Box>
                  </Box>
                </TableCell>
              </TableRow>
            ) : (
              medicalCertificates &&
              medicalCertificates.map(medicalCertificate => {
                return (
                  <FollowupReportListRow
                    handleClick={handleOpenDialog}
                    medicalCertificate={medicalCertificate}
                    seeCid={seeCID}
                    key={medicalCertificate.id}
                    headers={headers}
                  />
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <CustomTablePagination
        totalRows={totalRows}
        currentPage={currentPage}
        perPage={perPage}
        handleRequest={list}
        setPerPage={setPerPage}
        setCurrentPage={setCurrentPage}
        orderField={orderField}
        orderDirection={orderDirection}
      />
    </Container>
  );
};

export default FollowupReportList;
